import React, { useEffect, useState } from 'react';

function MobileSignInBanner({ onSignInClick }) {
  // Only show on mobile when user is not logged in
  // This is controlled by the parent component
  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    // Trigger slide-down animation after component mounts
    const timer = setTimeout(() => setIsMounted(true), 50);
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div className={`sm:hidden fixed top-[100px] left-0 right-0 z-40 bg-gradient-to-r from-primary via-primary-dark to-secondary text-white px-4 py-2.5 shadow-lg ${isMounted ? 'animate-banner-slide-down' : 'opacity-0 -translate-y-full'}`}>
      <div className="max-w-screen-2xl mx-auto flex items-center justify-between gap-3">
        <div className="flex-1 overflow-hidden">
          <p className="text-sm font-medium animate-text-slide whitespace-nowrap">
            Sign in for best experience
          </p>
        </div>
        <button
          onClick={onSignInClick}
          className="bg-white text-primary font-semibold px-4 py-1.5 rounded-lg hover:bg-gray-100 transition-all shadow-md whitespace-nowrap text-sm animate-button-pulse hover:scale-105 active:scale-95"
        >
          Sign In
        </button>
      </div>
    </div>
  );
}

export default MobileSignInBanner;
